<!--
 * @Descripttion: 
 * @version: 
 * @Author: sueRimn
 * @Date: 2020-05-19 14:35:20
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-07-13 10:40:53
 -->
 <!--
 * @Descripttion: 
 * @version: 
 * @Author: lrs
 * @Date: 2019-12-11 16:33:03
 * @LastEditors: mrh
 * @LastEditTime: 2020-05-19 14:34:18
 -->

<template>
  <div class="videoup">
    地方地方乱码了是了类似龙胜大浪费了发
  </div>
</template>
<script>
// import { todayUploadViveo, delViveoById } from "@/api/join";
// import { playUrl } from "@/api/myGoods/myGoods";
export default {
  data() {
    return {
      // headerMsg: {},
      // videoList: [], //视频列表
      // showVideo: false, //是否展示视频播放组件
      // videosrc: "", //视频播放组件的url
      // isBoss: true, //是否是菜老板上传档口视频
      // empty: true, //是否展示按钮组
      // loading: false, //遮罩
      // upSuccess: false //是否上传成功
    };
  },
  mounted() {
    // this.todayUploadViveo();
    console.log(jjjj.efg)
  },
  methods: {
  },
  computed: {
    // name() {
    //   // 返回视频名称
    //   return this.videoList.length > 0 ? this.videoList[0].cfpName : "";
    // }
  }
};
</script>
<style lang="scss" scoped>
.videoup {
  
}
</style>
